import template from './successfulAction.html';
import controller from './successfulAction.controller';
import './successfulAction.scss';

let successfulActionComponent = {
  restrict: 'E',
  bindings: {
    closeModal: '@',
    modalId: '@',
    modalIdToClose: '@',
    onDismiss: '&',
    title: '@',
    message: '@',
    messageJourney: '@',
    description: '<',
    descriptionBig: '@',
    onClick: '&',
    isMobileApp: '<',
    withoutManager: '<',
    scrollableBody: '<',
    repaymentMessage:'<',
  },
  transclude: {
    descriptionTextarea: '?descriptionTextarea',
  },
  template,
  controller,
};

export default successfulActionComponent;



// WEBPACK FOOTER //
// ./client/app/components/successfulAction/successfulAction.component.js